import React from 'react';
import ShieldShareIcon from '../../library/icons/shield-share-icon';
import ProgressComponent from '../../library/components/progress-component';

const MagicLinkValidtatingComponent = () => {
    return (
        <div className="linkcontent">
            <div className="img">
                <ShieldShareIcon />
            </div>
            <h2>Hold tight while we direct you</h2>
            <ProgressComponent
                width={400}
                message="Validating share link"
                variant="indeterminate"
            />
        </div>
    );
};

export default MagicLinkValidtatingComponent;
